export default __webpack_public_path__ + "static/media/compactor.b89ed00a.pdf";